import React, { useEffect, useState } from 'react';
import axios from 'axios';
import UserProfile from './ProfileComponents.js/UserProfile';
import SuggestedGroup from './DashSubComponents/SuggestedGroup';
import YourGroups from './DashSubComponents/YourGroups';
import Footer from './DashSubComponents/Footer';
import ProfileTabs from './ProfileComponents.js/ProfileTabs';
import DashBarProgress from './DashSubComponents/DashBarProgress';
import { BASE_URL } from '../Utils/BaseUrl';
import landscape from '../../images/landscape.jpg'
const Profile = () => {

    const [hide] = useState(false);
    const [cover, setCover] = useState("");
    const [preview, setPreview] = useState("");

    const user_id = localStorage.getItem("user_id");

    /* ================= GET COVER ================= */
    const getCover = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/get_cover`, { user_id });

            if (res.data.cover_image) {
                setCover(res.data.cover_image);
            }

        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getCover();
    }, []);

    /* ================= HANDLE FILE ================= */
    // const handleFileChange = async (e) => {
    //     const file = e.target.files[0];

    //     if (!file) return;

    //     // preview
    //     setPreview(URL.createObjectURL(file));

    //     const formData = new FormData();
    //     formData.append("cover", file);
    //     formData.append("user_id", user_id);

    //     try {
    //         const res = await axios.post(`${BASE_URL}/upload_cover`, formData, {
    //             headers: { "Content-Type": "multipart/form-data" }
    //         });

    //         if (res.data.status === 1) {
    //             setCover(res.data.image);
    //         }

    //     } catch (err) {
    //         console.log(err);
    //     }
    // };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // preview instantly
        setPreview(URL.createObjectURL(file));

        const formData = new FormData();
        formData.append("cover", file);
        formData.append("user_id", user_id);

        try {
            const res = await axios.post(`${BASE_URL}/upload_cover`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            if (res.data.status === 1) {
                setCover(res.data.image);

                // 🔥 IMPORTANT: remove preview after upload
                setTimeout(() => {
                    setPreview("");
                    getCover(); // reload from DB
                }, 500);
            }

        } catch (err) {
            console.log(err);
        }
    };
    return (
        <>
            {/* ================= COVER SECTION ================= */}
            <section className="cover-sec">

                <img
                    src={
                        preview
                            ? preview
                            : cover
                                ? `https://thetalentclub.co.in/upload/cover/${cover}?t=${new Date().getTime()}`
                                : landscape
                    }
                    alt="cover"
                //   style={{
                //     width: "100%",
                //     height: "300px",
                //     objectFit: "cover"
                //   }}
                />
                <div className="add-pic-box">
                    <div className="container">
                        <div className="row no-gutters">
                            <div className="col-lg-12 col-sm-12 text-center">

                                <input
                                    type="file"
                                    id="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    onChange={handleFileChange}
                                />
                                <label
                                    htmlFor="file"
                                    className="btn"
                                >
                                    Change Image
                                </label>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ================= MAIN ================= */}
            <main className={hide ? "overlay" : ""}>
                <div className="main-section">
                    <div className="container">
                        <div className="main-section-data">
                            <div className="row">

                                {/* LEFT */}
                                <div className="col-lg-3 col-md-4 no-pd">
                                    <UserProfile />
                                    <SuggestedGroup />
                                    <Footer />
                                </div>

                                {/* CENTER */}
                                <div className="col-lg-6 col-md-8 no-pd">
                                    <ProfileTabs />
                                </div>

                                {/* RIGHT */}
                                <div className="col-lg-3 no-pd">
                                    <div className="card mb-3 p-2 text-center">
                                        <DashBarProgress />
                                    </div>
                                    <YourGroups />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Profile;